import React, { ReactNode } from "react";
import VLCropper, { VLCropperRef } from "../../../uikit/VLCropper";
import IconButton from "../../../uikit/Buttons/IconButton";
import { VisualSimilarityIcon } from "../../../pages/DataPage/CardsView/DataPageFilters/SearchContainer/Icons";
import styles from "./style.module.scss";
import { ASSERT_PREVIEW_CROP_BOX_SIZE_RATIO } from "views/uikit/VLCropper/constants";

interface CroppablePreviewProps {
  children: ReactNode;
  isVQLUpgradeEnabled: boolean;
  isFindSimilarButtonSelected: boolean;
  cropperRef: React.RefObject<VLCropperRef>;
  cropperSrc: string;
  onSubmit: (e: React.MouseEvent) => void;
}

const CroppablePreview: React.FC<CroppablePreviewProps> = ({
  children,
  isVQLUpgradeEnabled,
  isFindSimilarButtonSelected,
  cropperRef,
  cropperSrc,
  onSubmit,
}) => {
  return (
    <div className={styles.previewWrapper}>
      {children}

      {/* VLCropper overlay when find similar is selected */}
      {isVQLUpgradeEnabled && isFindSimilarButtonSelected && (
        <>
          <div className={styles.cropperSubmitButton}>
            <IconButton
              onClick={onSubmit}
              text="Find Similar"
              variant={"success"}
              icon={<VisualSimilarityIcon />}
            />
          </div>
          <div
            className={styles.cropperOverlay}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            onMouseMove={(e) => e.stopPropagation()}
            onMouseUp={(e) => e.stopPropagation()}
          >
            <VLCropper
              ref={cropperRef}
              src={cropperSrc}
              autoCrop={true}
              cropBoxSizeRatio={ASSERT_PREVIEW_CROP_BOX_SIZE_RATIO}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default CroppablePreview;
